import React from 'react';
import PropTypes from 'prop-types';
import { ErrorAlert, SuccessAlert, WarningAlert } from 'smartsuite-ui';
import { useLabelContext } from '../../shared/hooks/labelContext';

/* eslint-disable complexity */
export default function ShareUrlCopyAlert(props) {
    const { dashboardLabels } = useLabelContext();

    if (!props.hasCopyBeenClicked) {
        return null;
    }

    if (!props.isCopyingSuccessful) {
        return (
            <ErrorAlert>{dashboardLabels.unableToCopyToClipboard}</ErrorAlert>
        );
    }

    if (!props.unappliedFiltersExist) {
        return <SuccessAlert>{dashboardLabels.copiedToClipboard}</SuccessAlert>;
    }

    const unappliedFiltersMessage = `${dashboardLabels.copiedToClipboard} - ${dashboardLabels.copiedToClipboard}`;
    return <WarningAlert>{unappliedFiltersMessage}</WarningAlert>;
}
/* eslint-enable complexity */

ShareUrlCopyAlert.propTypes = {
    hasCopyBeenClicked: PropTypes.bool.isRequired,
    isCopyingSuccessful: PropTypes.bool.isRequired,
    unappliedFiltersExist: PropTypes.bool.isRequired,
};
